// @ts-strict-ignore
import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { CalendarDay } from '@fc-shared/ui/shcedule-calendar/types';
import * as calendarActions from '@fc-shared/ui/shcedule-calendar/store/schedule-calendar.actions';

export const scheduleCalendarKey = 'schedule_calendar_key';

export interface State {
  clickedDay: CalendarDay;
}

export const initialState: State = {
  clickedDay: null,
};

export const scheduleCalendarReducer = createReducer(
  initialState,
  on(calendarActions.setClickedDay, (state, action) => ({
    ...state,
    clickedDay: action.date,
  })),
  on(
    calendarActions.clearCurrentDay,
    (state): State => ({
      ...state,
      clickedDay: null,
    }),
  ),
);

export const getCalendarState =
  createFeatureSelector<State>(scheduleCalendarKey);
export const getCurrentDayState = (state: State) => state.clickedDay;
